import React, { useState } from "react";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import styles from "./PainelLogin.module.css";

export default function PainelLogin() {
    const { login } = useAuth();
    const [passwordInput, setPasswordInput] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);
        setError("");

        login(passwordInput)
            .catch((err) => setError(err.message || "Senha inválida."))
            .finally(() => setIsLoading(false));
    };

    return (
        <main className={styles.loginPage}>
            <form className={styles.loginPanel} onSubmit={handleSubmit}>
                <ShieldCheck size={34} aria-hidden="true" />
                <h1>Painel HL Software</h1>
                <p>Acesse a área administrativa do site.</p>
                <label htmlFor="painel-password">Senha</label>
                <input
                    id="painel-password"
                    type="password"
                    value={passwordInput}
                    onChange={(e) => setPasswordInput(e.target.value)}
                    autoComplete="current-password"
                    required
                />
                <button type="submit" disabled={isLoading}>
                    {isLoading ? "Entrando..." : "Entrar"}
                </button>
                {error && <p className={styles.errorMessage}>{error}</p>}
            </form>
        </main>
    );
}
